import './FileDrop.scss';

import React, { useContext } from 'react';

import Dropzone from 'react-dropzone';
import 'react-dropzone-uploader/dist/styles.css';

import { NCRContext } from "views";

const FileDrop = () => {

  const { state, setState } = useContext(NCRContext);

  const isDisabled = state.ncr.status.id > 5;

  /**
   * FUNCTION: onDrop
   * This function will set the ncr.files to the added files
   * @param acceptedFiles - files added to the dropzone
   */
  const onDrop = (acceptedFiles) => {
    setState(prev => {
      prev.uploads = [...prev.uploads, ...acceptedFiles];
      return { ...prev };
    });
  }

  return (
    !isDisabled &&
    <Dropzone onDrop={acceptedFiles => onDrop(acceptedFiles)}>
      {({ getRootProps, getInputProps }) => (
        <>
          <div className={'dropzone highlight'} {...getRootProps()}>
            <input {...getInputProps()} />
            <p>
              Click or drag files inside this box to upload.
            </p>
          </div>
        </>
      )}
    </Dropzone>
  )
}

export { FileDrop };
